import "suus-component-library/styles.css";
import "./assets/styles/fonts.css";
import "./assets/styles/root.css";
import "suus-design-tokens/tokens.css";
import {useEffect, useState} from "react";

import Header from "./app/workplace/components/header/header.tsx";
import Footer from "./app/workplace/components/footer/footer.tsx";
import Content from "./app/workplace/components/content/content.tsx";
import {useViewportHeight} from "./app/workplace/services/hooks/useViewPort.ts";
import { reactGA } from "./app/workplace/utils/google-analytics.ts";
import splashImage from "./assets/features/workplace/images/splash.jpeg";
import {LiquidImage} from "@/splash.tsx";

reactGA.initialize("G-HSLDJ50H8M");

const MOBILE_AND_TABLET_MEDIA_QUERY = "(max-width: 1024px)";
const SPLASH_SCREEN_DURATION_MS = 3000;
const SPLASH_SCREEN_SESSION_KEY = "suus-splash-screen-shown";

function App() {

    useViewportHeight();
    const [showSplash, setShowSplash] = useState(() => {
        const isMobileOrTablet = window.matchMedia(MOBILE_AND_TABLET_MEDIA_QUERY).matches;
        const isSplashAlreadyShown = sessionStorage.getItem(SPLASH_SCREEN_SESSION_KEY) === "true";
        return isMobileOrTablet && !isSplashAlreadyShown;
    });

    useEffect(() => {
        if (!showSplash) {
            return;
        }

        sessionStorage.setItem(SPLASH_SCREEN_SESSION_KEY, "true");

        const timer = window.setTimeout(() => {
            setShowSplash(false);
        }, SPLASH_SCREEN_DURATION_MS);

        return () => {
            window.clearTimeout(timer);
        };
    }, [showSplash]);

    if (showSplash) {
        return (
            <div className="app-splash-screen" role="status" aria-live="polite">
                <div className="app-splash-screen__content">
                    <div>
                        {/* Pfad zu deinem Originalbild übergeben */}
                        <LiquidImage src={splashImage} intensity={10} />
                    </div>
                    {/*<span className="app-splash-screen__brand">SUUS</span>*/}
                    {/*<br />*/}
                    {/*<p>Quench your thirst</p>*/}
                </div>
            </div>
        );
    }

    return (
        <div className="my-viewport">
            <Header/>
            <Content />
            <Footer/>
        </div>
  )
}

export default App
